export default axiosInstance => {
  async function generate({ jwt }) {
    return (
      await axiosInstance({
        method: "get",
        url: "/liff/visit/qrcode",
        headers: {
          jwt
        }
      })
    ).data;
  }

  async function scan({ jwt, qrcode }) {
    return (
      await axiosInstance({
        method: "post",
        url: "/liff/visit/qrcode",
        headers: {
          jwt
        },
        data: { qrcode }
      })
    ).data;
  }

  async function query({ jwt }) {
    return (
      await axiosInstance({
        method: "get",
        url: "/liff/visit",
        headers: {
          jwt
        }
      })
    ).data;
  }

  return {
    generate,
    scan,
    query
  };
};
